var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { useStoreState } from "pullstate";
import { faMinus, faPlus, faStars, faWindowMaximize, faWindowRestore, faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
import Store from "../../../utils/Store";
import { trackEvent } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../utils/mixpanelEvents";
import NewChatModal from "../NewChatModal";

/**
 * Window chrome for the assistant: title, New Chat, and the
 * minimise/maximise/close controls.
 *
 * Deliberately knows nothing about where messages come from. The CopilotKit
 * chat and the orqestrator chat keep their messages in different places, so the
 * two facts this needs (is there anything to clear, and how to clear it) are
 * passed in rather than read from a store.
 */

var Header = function Header(_ref) {
  var title = _ref.title,
    hasMessages = _ref.hasMessages,
    onNewChat = _ref.onNewChat;
  var _useState = useState(false),
    showNewChatModal = _useState[0],
    setShowNewChatModal = _useState[1];
  var _useState2 = useState(false),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isDraggableModalMaximized: s.isDraggableModalMaximized
      };
    }),
    isDraggableModalMaximized = _useStoreState.isDraggableModalMaximized;
  useEffect(function () {
    if (typeof window !== "undefined") {
      setIsMobile(window.matchMedia("(max-width: 639px)").matches);
    }
  }, []);
  var handleConfirmNewChat = function handleConfirmNewChat() {
    onNewChat();
    setShowNewChatModal(false);
    trackEvent(MIXPANEL_EVENTS.ASSISTANT_MODAL_BUTTONS, {
      button_type: "new_chat",
      action: "click"
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "drag-handle cursor-move flex items-center bg-gray-700 p-4 border-b dark:bg-gray-900 border-teal-800 text-white shadow-[0_4px_24px_rgba(20,50,100,0.85)]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faStars,
    size: "lg",
    className: "text-white p-1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-3 text-lg"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end items-center"
  }, hasMessages && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "group flex items-center relative"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setShowNewChatModal(true);
    },
    "aria-label": "New Chat",
    title: "New Chat",
    className: "group flex items-center text-white hover:text-gray-200 p-2 transition-all duration-200"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-2 text-base font-medium text-teal-400 whitespace-nowrap bg-white dark:bg-gray-900 px-3 py-1 rounded shadow-md border border-teal-200 dark:border-teal-700 z-10 transition-all duration-300 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0"
  }, "New Chat"), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPlus,
    size: "sm"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-6 w-px bg-gray-600 mx-3"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3"
  }, !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalMinimized = !s.isDraggableModalMinimized;
      });
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_MODAL_BUTTONS, {
        button_type: "minimize",
        action: "click",
        is_minimized: !Store.getRawState().isDraggableModalMinimized
      });
    },
    "aria-label": "Minimize",
    title: "Minimize",
    className: "text-white hover:text-teal-400 p-1 px-2 rounded-full transition-all duration-200 hover:scale-110"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMinus,
    size: "sm"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalMaximized = !s.isDraggableModalMaximized;
      });
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_MODAL_BUTTONS, {
        button_type: "maximize",
        action: "click",
        is_maximized: !isDraggableModalMaximized
      });
    },
    "aria-label": "Maximize",
    title: "Maximize",
    className: "text-white hover:text-teal-400 p-1 px-2 rounded-full transition-all duration-200 hover:scale-110"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isDraggableModalMaximized ? faWindowRestore : faWindowMaximize,
    size: "sm"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalOpen = !s.isDraggableModalOpen;
      });
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_MODAL_BUTTONS, {
        button_type: "close",
        action: "click"
      });
    },
    "aria-label": "Close",
    title: "Close",
    className: "text-white hover:text-teal-400  p-1 px-2 rounded-full transition-all duration-200 hover:scale-120"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "sm"
  }))))), /*#__PURE__*/React.createElement(NewChatModal, {
    isOpen: showNewChatModal,
    onConfirm: handleConfirmNewChat,
    onCancel: function onCancel() {
      return setShowNewChatModal(false);
    }
  }));
};
export default Header;